import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import * as recordListActions from './reducer';
import OrderSummary from './OrderSummary';
import RFQSummary from './RFQSummary';
import { TYPE } from '../utility/types';

import './RecordList.css';

export class RecordListComponent extends Component {
  static get propTypes() {
    return {
      user: PropTypes.shape({
        CanView: PropTypes.bool
      }),
      type: PropTypes.string,
      selectedId: PropTypes.number,
      fetching: PropTypes.bool,
      fetchedType: PropTypes.string,
      records: PropTypes.array,
      editingDraft: PropTypes.bool,
      onFetch: PropTypes.func.isRequired,
      onFetchMore: PropTypes.func.isRequired,
      searchParams: PropTypes.string,
      appInitialised: PropTypes.bool  
    };
  }

  constructor(props) {
    super(props);
    const { type, searchParams, user, onFetch } = this.props;
    if (user && user.CanView)
    {
       onFetch(type, searchParams);
    }
  }

  componentWillReceiveProps(props) {
    if (props.type === this.props.type && props.searchParams === this.props.searchParams
          && props.records && props.records.length) {
      setTimeout(() => {
        this.checkScroll();
      }, 100);
    } else if (props.user && props.user.CanView) {
      this.props.onFetch(props.type, props.searchParams);
    }
  }

  setListElement(list) {
    this.listElement = list;
  }

  checkScroll() {
    const { type, searchParams } = this.props;
    if (this.listElement &&
        this.listElement.scrollTop + this.listElement.clientHeight
                >= this.listElement.scrollHeight - 300) {
      this.props.onFetchMore(type, searchParams);
    }
  }

  render() {
    const { type, fetchedType, records, editingDraft, fetching } = this.props;

    const itemRenderer = (type === TYPE.ORDER)
      ? r => this.renderOrder(r)
      : r => this.renderRFQ(r);

    return (
      <div
        className="RecordList"
        tabIndex="0"
        onScroll={() => this.checkScroll()}
        ref={l => this.setListElement(l)}
      >
        {(type === fetchedType) ?
          <ul className="RecordList-list">
            {editingDraft && this.renderDraft()}
            {records.map(r => itemRenderer(r))}
          </ul>
          : undefined }

        { (fetching || !records || !records.length) && <div className="RecordList-fetching">
          {fetching
            ? 'Fetching records...'
            : 'No records to display'}
        </div>}
      </div>
    );
  }

  renderOrder(record) {
    const { selectedId, searchParams } = this.props;
    const id = record.OrderNumber;
    const selected = selectedId === id;

    return (<li key={id} className={classnames('RecordList-item', { selected })}>
      <Link to={`/order/${id}${searchParams}`}>
        <OrderSummary order={record} />
      </Link>
    </li>);
  }

  renderRFQ(record) {
    const { selectedId, searchParams } = this.props;
    const id = record.RFQNumber;
    const selected = selectedId === id;

    return (<li key={id} className={classnames('RecordList-item', { selected })}>
      <Link to={`/rfq/${id}${searchParams}`}>
        <RFQSummary rfq={record} selected={selected} />
      </Link>
    </li>);
  }

  renderDraft() {
    return (<li className="RecordList-item selected">
      <div className="DraftSummary">DRAFT</div>
    </li>);
  }
}

const mapStateToProps = state => ({
  user: state.user.current,
  fetching: state.recordList.fetching,
  fetchedType: state.recordList.type,
  records: state.recordList.records,
  filterQuerystring: state.recordList.filterQuerystring,
  editingDraft: state.recordDetail.editing && !state.recordDetail.currentId,
  appInitialised: state.recordList.appInitialised
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchRecordsIfNeeded,
    fetchMoreRecords,
    setDisplayFilter
  } = bindActionCreators(recordListActions, dispatch);
  return {
    onFetch: fetchRecordsIfNeeded,
    onFetchMore: fetchMoreRecords,
    setDisplayFilter
  };
};

const RecordList = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecordListComponent));
export default RecordList;



// WEBPACK FOOTER //
// ./src/recordList/RecordList.js